import HTMLElementBuilder from './HTMLElementBuilder';

export default class DivisionBuilder extends HTMLElementBuilder<HTMLDivElement> {
	public constructor() { super('div'); }
}
